/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_CREDENTIAL_COUNT = gql`
  query CredentialAnalytics(
    $wp: GetCredentialCountInput
    $total: GetCredentialCountInput
    $csme: GetCredentialCountInput
    $csmev: GetCredentialCountInput
    $mec: GetCredentialCountInput
    $roe: GetCredentialCountInput
  ) {
    wp: getCredentialCount(input: $wp)
    csme: getCredentialCount(input: $csme)
    csmev: getCredentialCount(input: $csmev)
    mec: getCredentialCount(input: $mec)
    roe: getCredentialCount(input: $roe)
    total: getCredentialCount(input: $total)
  }
`;
